import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GlobalService } from '../../../core/services/global.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loading: boolean = false;

  form: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl(null, Validators.required),
    password: new UntypedFormControl(null, Validators.required)
  })

  constructor(
    private _globalService: GlobalService,
  ) { }

  ngOnInit(): void {
    this._globalService.logout();
  }

  login(){
    if(this.form.valid){
      this.form.patchValue({
        email: this.form.value.email.trim()
      }) 

      this.loading = true;

      this._globalService.login(this.form.value).subscribe((res:any)=>{
        if(res.status){
          console.log("ACAAA")
          console.log(res)
          switch(res.status){
            case 200:
              //this._globalService.createToast('success', 'Bienvenido', this.form.value.email)
              break;
            case 404:
              this._globalService.createToast('error', 'Revisa los datos...', 'No se encontro ningun usuario con ese email')
              return;
            case 403:
              this._globalService.createToast('error', 'Revisa los datos...', 'El email o la contraseña es incorrecta')
              return;
            default:
              this._globalService.createToast('error', 'Upss...', 'Hubo un error al iniciar sesion, intentalo de nuevo...');
              return;
          }

          this._globalService.setProfile(res.data[0].profile);
          this._globalService.setToken(res.data[0].token);

          this._globalService.navigate('/admin');

        }
      }, (error)=>{
        this.loading = false;
        this._globalService.createToast('error', 'Upss...', 'Hubo un error al iniciar sesion, intentalo de nuevo...');
      }, ()=>{  
        this.loading = false;
      })
    }
  }

}
